"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceSans3 = void 0;
var css_1 = require("@emotion/css");
(0, css_1.injectGlobal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @import url('https://fonts.googleapis.com/css?family=Source+Sans+3:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&display=swap&bengali,latin-ext');\n"], ["\n  @import url('https://fonts.googleapis.com/css?family=Source+Sans+3:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&display=swap&bengali,latin-ext');\n"])));
exports.sourceSans3 = "'Source Sans 3', sans-serif";
var templateObject_1;
//# sourceMappingURL=index.js.map